import { HttpService, RESTMethods, VisibaHttpOption } from '@application/http.service';
import { UniversalConfig } from '@application/universal_config.service';
import { Injectable } from '@visiba/instantiation';

/**
 * This service's only purpose is to fetch svg images and return the data
 */
@Injectable()
export class SvgHttpService {
	constructor(private readonly universalConfig: UniversalConfig) {
		// Empty
	}

	public get(imgSrc: string) {
		return HttpService.send<string, Error>(RESTMethods.GET, imgSrc, new VisibaHttpOption(this.universalConfig, { parseAs: 'text' }));
	}
}
